const rawBase = process.env.REACT_APP_API_BASE_URL;

function normalizeBase(base) {
  return String(base || '/api').replace(/\/$/, '');
}

function resolveDevApiBase(base) {
  if (typeof window === 'undefined') return base;
  if (process.env.NODE_ENV !== 'development') return base;
  if (!/localhost|127\.0\.0\.1/i.test(base)) return base;

  try {
    const url = new URL(base);
    const port = url.port || '3021';
    const pathname = (url.pathname || '/api').replace(/\/$/, '') || '/api';
    return `${url.protocol}//${window.location.hostname}:${port}${pathname}`;
  } catch {
    return `http://${window.location.hostname}:3021/api`;
  }
}

export const API_BASE_URL = resolveDevApiBase(
  normalizeBase(rawBase === undefined || rawBase === '' ? '/api' : rawBase),
);

export function apiUrl(path) {
  if (/^https?:\/\//i.test(path)) return path;
  let normalized = path.startsWith('/') ? path : `/${path}`;
  if (!API_BASE_URL) return normalized;
  if (normalized.startsWith('/api/')) {
    normalized = normalized.slice(4);
  } else if (normalized === '/api') {
    normalized = '';
  }
  return `${API_BASE_URL}${normalized.startsWith('/') ? normalized : `/${normalized}`}`;
}
